<!-- @format -->

<template>
	<div style="padding: 0 15px" @click="toggleClick">
		<template v-if="isActive">
			<icon-ant-design-menu-fold-outlined />
		</template>
		<template v-else>
			<icon-ant-design-menu-unfold-outlined />
		</template>
	</div>
</template>

<script setup>
	defineProps({
		isActive: {
			type: Boolean,
			default: false,
		},
	});

	const emit = defineEmits(['toggleClick']);

	const toggleClick = () => {
		emit('toggleClick');
	};
</script>

<style scoped>
	.hamburger {
		display: inline-block;
		vertical-align: middle;
		width: 20px;
		height: 20px;
	}

	.hamburger.is-active {
		transform: rotate(180deg);
	}
</style>
